import mapValues from "lodash.mapvalues";
/**
 * Makes program account parsers.
 * @param parsers
 * @returns
 */
export const makeProgramAccountParsers = ({ address, accountParsers, }) => {
    return mapValues(accountParsers, (parser, name) => ({
        name,
        programID: address,
        parse: parser,
    }));
};
//# sourceMappingURL=programAccounts.js.map